var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16 7.563c.001 0 7.505 0 9.377.504a3.02 3.02 0 0 1 2.122 2.135c.5 1.877.501 5.786.501 5.815 0 0 0 3.93-.501 5.814-.276 1.04-1.09 1.823-2.122 2.102-1.871.504-9.376.505-9.377.505 0 0-7.505 0-9.377-.505a2.97 2.97 0 0 1-2.122-2.102C4 19.947 4 16.017 4 16.017c0-.03.001-3.937.501-5.814a3.02 3.02 0 0 1 2.122-2.136C8.495 7.563 16 7.562 16 7.562m-2.455 12.022 6.272-3.567-6.272-3.57z"
  })));
};
export default SvgYoutube;